import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import {
  FaUserFriends,
  FaUsers,
  FaThLarge,
  FaArrowLeft,
  FaBuilding,
} from "react-icons/fa";
import { IoMdAddCircleOutline, IoMdMenu } from "react-icons/io";
import { NavLink, useLocation } from "react-router-dom";
import { MdEventBusy } from "react-icons/md";
import { FiLogOut } from "react-icons/fi";

import { useNavigate } from "react-router-dom";
import { UseHrApp } from "../../utils/context";

const drawerWidth = 240;



function ResponsiveDrawer(props) {
  const navigate = useNavigate();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  function LogOut() {
    localStorage.removeItem("token");
    navigate("/");
  }

  const { token } = UseHrApp();

  const drawer = (
    <div className=" h-screen text-black bg-[white]">
      <Toolbar className="h-[12vh] flex gap-2 items-center ">
        <FaUserFriends size={25} color="#9a6aff" />
        <p className=" font-[Righteous] text-2xl text-black">
          HRXpert<small className="  text-xs">ADMIN</small>
        </p>
      </Toolbar>
      <Divider />
      <div className="w-full min-h-[80%] pt-[2em] flex flex-col justify-between">
        <List className="p-3">
          {[
            {
              name: "Dashboard",
              route: "/admin/mainDash/main",
              logo: <FaThLarge size={17} />,
            },

            {
              name: "Leaves",
              route: "/admin/mainDash/leaves",
              logo: <MdEventBusy size={17} />,
            },
            {
              name: "Employees",
              route: "/admin/mainDash/employees",
              logo: <FaUsers size={17} />,
            },
            {
              name: "Department",
              route: "/admin/mainDash/department",
              logo: <FaBuilding size={17} />,
            },
       
          ].map((item, index) => (
            <ListItem key={index}>
              <NavLink
                to={item.route}
                className=" flex gap-2 w-full h-full items-center justify-center hover:border-[2px] hover:border-[#081226S] pl-3 py-2 rounded-[15px]"
              >
                {item.logo}
                <ListItemText primary={item.name} />
              </NavLink>
            </ListItem>
          ))}
        </List>

        {/* <div className=" h-[7em] flex flex-col w-full justify-center items-center">
        <div className=" p-3 rounded-[2em] text-white bg-[#081226] ">
          <p className=" uppercase">{props.ini}</p>

        </div>
<p className=" font-semibold text-lg">{props.userName}</p>
<p className="text-sm">{props.email}</p>
        </div>*/}
      </div>
      <Divider />
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const [shown, setshown] = React.useState(false);

  const location = useLocation();

  React.useEffect(() => {
    // This code will run after the component has rendered
    if (location.pathname === "/admin/mainDash/employees/view") {
      setshown(true);
    }
  }, [location.pathname]);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: {
            sm: `${drawerWidth}px
  
          
          `,
          },
          background: "white",
          boxShadow: "none",
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <IoMdMenu className=" text-black" />
          </IconButton>
          {shown && (
            <button
              className=" text-black"
              onClick={() => {
                navigate("/admin/mainDash/employees");
                setshown(false);
              }}
            >
              <FaArrowLeft />
            </button>
          )}

          <div className="end gap-6 w-[85%] lg:w-full h-full">
            <div className="flex justify-center items-center gap-2 p-2 rounded-[30px] bg-[#daeaff] ">
              <div className=" rounded-[10em] w-[30px] h-[30px]  bg-[#1E2029] flex justify-center items-center">
                <p>A</p>
              </div>
              <p className="text-black">Admin</p>
            </div>
            <button
              className="flicker-button w-[35px] h-[35px] flex justify-center items-center rounded-[30px]  hover:bg-gray-400 active:bg-gray-500 relative overflow-hidden"
              onClick={LogOut}
            >
              <FiLogOut size={20} color="black" />
            </button>
          </div>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
            color: "black",
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,

          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
      </Box>
    </Box>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;
